import type { ProductListItem } from 'types/capi/shared';

import type { User } from '~/root';
import algolia from '~/services/algolia.client';

import UserEvent from './UserEvent';

type EventData = {
  isBot: boolean;
  product: ProductListItem;
  user: User;
};

class ProductClickedEvent extends UserEvent<EventData> {
  sendToAlgolia() {
    if (!this.data.product.queryID) return;
    if (!this.data.product.position) return;

    algolia.clickedObjectIdAfterSearch({
      id: this.data.product.id.toString(),
      position: this.data.product.position,
      queryID: this.data.product.queryID,
      user: this.data.user
    });
  }
}

export default ProductClickedEvent;
